(function () {
    'use strict';
    angular.module('templates', []);
    console.log("templates base loaded");
})();
